import {  useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppointmentContext } from '../../context/AppointmentContext'
import toast from 'react-hot-toast'

const YesNoOption = ({question, next, prev}) => {
  const { medicalhistory, setMedicalHistory } = useAppointmentContext();
    const [selected, setSelected] = useState("")
    const [optSelected, setOptSelected] = useState("")
    const {t}= useTranslation()

    useEffect(()=>{
       if(medicalhistory[question.id]){
          setSelected(medicalhistory[question.id].ans)
          if(medicalhistory[question.id].ans === "yes"){
            setOptSelected(medicalhistory[question.id].opt)
          }
        }
    },[question])

    const handleCheckboxes = (e)=>{
       const value = e.target.value
       if(value === selected){
        setSelected("")
        return
       }
       setSelected(value)
    }


    const handleOpt = (e)=>{
       const value = e.target.value
       if(value === optSelected){
        setOptSelected("")
        return
       }
       setOptSelected(value)
    }

    const handleNext = ()=>{
        if(selected ===  ""){
            toast.error(t('Please select an option'))
            return 
        }else{
            if(selected === "yes"){
                if(optSelected === ""){
                    toast.error(t('Please select an option'))
                    return  
                }
            }
            setMedicalHistory((prev) => ({
              ...prev,
              [question.id]: { ans: selected, opt: optSelected },
            }));

            const latestMedicalState = {...medicalhistory ,[question.id]: { ans: selected, opt: optSelected } }
            // setFormData({...formData, [question.id] : {ans : selected, opt:optSelected}})  
            next(latestMedicalState)      // here provide the handleNext function recieved in props
        }
    }

  return (
    <div className="flex flex-col items-center gap-4 w-full flex-1 p-2">
         <label className="uppercase text-white md:text-2xl text-md md:font-bold flex gap-2">
         <span className="underline">Q{question.id}:</span>
         <span>{t(question.q)}</span>
         </label>

         <div className="flex flex-col items-center gap-4 flex-1 md:text-2xl text-base">
            
              <label className="md:text-2xl text-lg uppercase text-white flex gap-2 items-center hover:cursor-pointer">
              <input
                type="checkbox"
                className=" w-6 h-6"
                value="yes"
                checked={selected === "yes"}
                onChange={handleCheckboxes}
              />
                {t("Yes")}</label>
           
           
              <label className="md:text-2xl text-lg uppercase text-white flex gap-2 items-center hover:cursor-pointer">
              <input
                type="checkbox"
                className=" w-6 h-6"
                value="no"
                checked={selected === "no"}
                onChange={handleCheckboxes}
              />
                {t("No")}</label>


          {selected === "yes" && <><label className="text-white uppercase md:text-2xl text-base">{t("PLEASE SELECT WHICH ONE")}</label>
          <div className="flex gap-10">
            {question?.subOpt?.map((option, index)=>{
              return <>
              <label className="md:text-2xl text-base uppercase text-white flex gap-2 items-center hover:cursor-pointer">
              <input
                type="checkbox"
                className=" w-6 h-6"
                value={option}
                checked={optSelected === option}
                onChange={handleOpt}
                />
                {t(option)}
              </label>
                </>
                
              })
            }
          </div>
          </>}
            </div>

      <div className="w-full flex justify-between">
       <button
         className="yellowButton py-2 px-4 rounded-3xl font-bold  mb-2 mr-2"
         onClick={prev}
       >
         {t("Back")}
       </button>
       <button
         className="yellowButton py-2 px-4 rounded-3xl font-bold  mb-2 mr-2"
         onClick={handleNext}
       >
         {t("Next")}
       </button>
     </div>
    </div>
  )
}

export default YesNoOption
